const R = require('ramda')
module.exports = function(object) {
  return R.propOr('','value',object);
};
